import { Navigate, Route, Routes } from 'react-router-dom'
import InteracWireListPage from './InteracWireListPage'

const DetailRouter = () => {
  //const { id } = useParams()

  return (
    <Routes>
      {/* <Route path="" element={<InteracWireDetailPage id={id!} />} /> */}
      <Route path="*" element={<Navigate to="../.." replace />} />
    </Routes>
  )
}

const InteracWireRouter = () => {
  return (
    <Routes>
      <Route path=":id/*" element={<DetailRouter />} />
      <Route path="*" element={<InteracWireListPage />} />
    </Routes>
  )
}

export default InteracWireRouter
